module.exports = __webpack_public_path__ + "static/scanner-2ba7947377191637e6b5f7abee8a926f.svg";